import { F0Box, F0Icon } from '@factorialco/f0-react'
import { Tooltip } from '@factorialco/f0-react/dist/experimental'
import { Link } from '@factorialco/f0-react/icons/app'

import { RawTag } from 'modules/job_catalog/components/customTags/RawTag'
import i18n from 'modules/core/lib/i18n'
import { safeAssetTypeAsIcon } from 'modules/it_management/components/AssetsList/utils'

import type { EquipmentDisplayItem } from 'modules/job_catalog/lib/equipmentUtils'

export interface EquipmentTagProps {
  item: EquipmentDisplayItem
}

const EquipmentTag = ({ item }: EquipmentTagProps) => {
  const categoryIcon = <F0Icon icon={safeAssetTypeAsIcon(item.typeName)} size="sm" />
  const inheritedIcon = (
    <F0Box display="flex" alignItems="center" justifyContent="center" width="sm" height="sm">
      <F0Icon icon={Link} size="sm" color="secondary" />
    </F0Box>
  )

  const right =
    item.isInherited && item.inheritedFromName ? (
      <Tooltip
        label={i18n.t('job_catalog.nodes.it_management.inherited_from', {
          nodeName: item.inheritedFromName,
        })}
      >
        <F0Box
          aria-label={String(
            i18n.t('job_catalog.nodes.it_management.inherited_from', {
              nodeName: item.inheritedFromName,
            })
          )}
          tabIndex={0}
        >
          {inheritedIcon}
        </F0Box>
      </Tooltip>
    ) : item.isInherited ? (
      inheritedIcon
    ) : undefined

  return <RawTag icon={categoryIcon} text={item.label} right={right} />
}

export default EquipmentTag
